import { Field } from 'api/tasks';
import { fixedProjectFields } from './fixed-fields-render';

export const getFiltredFieldIds = (
  searchText: string,
  fields: Field[],
): string[] => {
  if (!searchText) {
    return [...fields, ...fixedProjectFields].map(
      (field) => `${field.fieldId}`,
    );
  }

  return [...fields, ...fixedProjectFields]
    .filter(
      ({ fieldLabel, fieldName }) =>
        fieldLabel?.toLowerCase().includes(searchText.toLowerCase()) ??
        fieldName?.toLowerCase().includes(searchText.toLowerCase()),
    )
    .map((field) => `${field.fieldId}`); // faster that .toString()
};
